import { createContext, createElement, useContext, type ComponentType } from 'react';
export interface SchedulingCreditProps {
  clientId: string;
  businessUnitId?: string | undefined;
  compact?: boolean | undefined;
  prepaid?: boolean | undefined;
}
const Credit = createContext<ComponentType<SchedulingCreditProps> | null>(null);
export const SchedulingCreditProvider = Credit.Provider;
export function SchedulingCredit(props: SchedulingCreditProps) {
  const Component = useContext(Credit);
  return Component && props.clientId ? createElement(Component, props) : null;
}
